import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { ModulePermission } from '../../models/modulePermission/modulePermission';
import { UserGroupServiceService } from '../user-group/user-group.service.service';
import { ModulePermissionServiceService } from '../module-permission/module-permissio.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  
  private allPermissions: ModulePermission[] = [];
constructor(private readonly auth: AuthenticationService, private service : ModulePermissionServiceService){

  
 
}
  setPermissions(data: any[]): void {
    console.log(data);
    this.allPermissions = data;
  }

  getVisibleModules(): any[] {
     const local = localStorage.getItem('appModules');
 
    const data = local ? JSON.parse(local) : [] ; 
   let llPermissions = data ;
   console.log(llPermissions)
    return this.allPermissions
      .filter(mod => mod.hasPermission)
      .map(mod => ({
        ...mod,
        moduleOptions: mod.moduleOptions.filter((opt: { canView: any; canEdit: any; hasPermissions: any; modulesOptionSections: any; }) =>
          opt.canView || opt.canEdit || opt.hasPermissions ||
          (opt.modulesOptionSections || []).some((sec: { canView: any; canEdit: any; hasPermission: any; }) => sec.canView || sec.canEdit || sec.hasPermission)
        )
      }))
      .filter(mod => mod.moduleOptions.length > 0);
  }

  canAccessModule(moduleName: string): boolean {
    const mod = this.getVisibleModules().find(m => m.name === moduleName);
    return !!mod;
  }

  getModuleOptions(moduleName: string): any[] {
    const mod = this.getVisibleModules().find(m => m.name === moduleName);
    return mod?.moduleOptions || [];
  }
}